<template>
  <v-select v-model="prop.value" :options="prop.options"/>
</template>
<script>
export default {
  name: 'EnumInput',
  props: {
    prop: {}
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/editor/EnumInput.vue